module.exports = __webpack_public_path__ + "img/loginImg.c0c64fc0.png";